import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { UtilService } from "../service/util.service";
import { CookiesLocalService } from "../service/cookies-local.service";
import { ApplicantService } from "../service/applicant.service";
import { ToastrService } from "ngx-toastr";
import { ComponentBase } from "../base/component-base";
import { BehaviorModelChangeService } from "../service/behavior-model-change.service.service";

@Component({
  selector: "app-programme-selection",
  templateUrl: "./programme-selection.component.html",
  styleUrls: ["./programme-selection.component.css"],
})
export class ProgrammeSelectionComponent
  extends ComponentBase
  implements OnInit
{
  title = "Please select four programmes and respective funding.";

  applicantProgrammeSelection = [];

  funding = [
    { FundingId: "R", Name: "Regular" },
    { FundingId: "F", Name: "Fee Paying" },
  ];

  // programmes = [];
  applicantProgrammeLocal = [];
  allProgrammeData: any[];

  constructor(
    applicantService: ApplicantService,
    cookieLocal: CookiesLocalService,
    private router: Router,
    private utilService: UtilService,
    private toastr: ToastrService,
    behaviorModelChangeService: BehaviorModelChangeService
  ) {
    super(applicantService, cookieLocal, behaviorModelChangeService);
  }

  getFunding(programmeId) {
    let selectedProgramme = this.allProgrammeData.filter(
      (a) => a.ProgrammeId == programmeId
    )[0];

    if (!selectedProgramme) return [];

    if (selectedProgramme.IsFeePaying) {
      return [this.funding[1]];
    }
    return this.funding;
  }

  ngOnInit() {
    this.loadProgrammes();
    if (!this.applicantData.CampusId) {
      this.router.navigate(["/applicant/choose-campus"]);
    }
  }

  loadProgrammes() {
    this.applicantService
      .geApplicantProgrammeOfChoice(this.applicantData.ApplicationId)
      .subscribe((data) => {
        this.applicantProgrammeLocal = data.SelectedProgrammes;
        this.applicantProgrammeSelection = data.Choices;
      });
  }

  onProgrammeChanged(item, e) {
    let selectedProgrammeId = e.target.value;
    let selectedIdex = this.applicantProgrammeSelection.indexOf(item);
    this.applicantProgrammeSelection[selectedIdex].ProgrammeId =
      selectedProgrammeId;

    if (this.applicantData.IsForignStudent) {
      this.applicantProgrammeSelection[selectedIdex].ProgrammeFundingId = "F";
    }

    if (selectedProgrammeId == 4 || selectedProgrammeId == 12) {
      this.applicantProgrammeSelection[selectedIdex].ProgrammeFundingId = "F";
    }
  }

  isValidChoices() {
    let isAllProgrammeSelected =
      this.applicantProgrammeSelection.filter(
        (item) => item.ProgrammeCode == "" || item.ProgrammeFundingId == ""
      ).length == 0;
    let isDuplicated = this.checkDuplicateInObject(
      "ProgrammeId",
      this.applicantProgrammeSelection
    );
    return isAllProgrammeSelected && !isDuplicated;
  }

  save(form: any): boolean {
    if (!form.valid) {
      return false;
    }

    return true;
  }

  goToNext(form: any) {
    let data = this.applicantProgrammeSelection.map((item) => {
      return {
        ApplicantProgrammeOfChoiceId: 0,
        ApplicationId: item.ApplicationId,
        ChoiceIndex: item.ChoiceIndex,
        ProgrammeId: item.ProgrammeId,
        ProgrammeFundingId: item.ProgrammeFundingId,
      };
    });

    if (
      this.isCertificateStudent() ||
      this.isDiplomaStudent() ||
      this.isPostgraduateStudent()
    ) {
      data.forEach((element) => {
        element.ProgrammeFundingId = "F";
      });
    }
    this.applicantService.saveApplicaitonProgrammeOfChoice(data).subscribe(
      (data) => {
        this.toastr.success("Programme Choice has been updated");
        this.router.navigate(["/applicant/info/application-summary"]);
      },
      (error) => {
        console.log(error);
      }
    );
  }

  goToPrevious() {
    this.router.navigate(["/applicant/info/exam-info"]);
  }

  checkDuplicateInObject(propertyName, inputArray) {
    var seenDuplicate = false,
      testObject = {};

    inputArray.map(function (item) {
      var itemPropertyName = item[propertyName];
      if (itemPropertyName in testObject) {
        testObject[itemPropertyName].duplicate = true;
        item.duplicate = true;
        seenDuplicate = true;
      } else {
        testObject[itemPropertyName] = item;
        delete item.duplicate;
      }
    });

    return seenDuplicate;
  }
}
